module.exports = __webpack_public_path__ + "static/media/JamesBond.7b946152.png";